import { useEffect, useMemo, useState } from 'react';
import { getAllBlogs } from '../../../providers/apis/blogApi';
import { HubFeatureCard } from '../layout/HubFeatureCard';
import { HubListingView } from '../layout/HubListingView';
import { usePaginatedItems } from '../layout/usePaginatedItems';

function parseBlogs(blogs) {
  return blogs.map((bItem) => ({
    postId: bItem.id,
    postType: bItem.Content_Type,
    title: bItem.Title,
    postDate: bItem.DateWritten,
    postMedia: bItem.Graphic1,
    postName: bItem.Relevance,
    creator: bItem.Author,
    content: bItem.Description,
  }));
}

export function BlogCardList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const firstItem = items[0];
  const listItems = useMemo(() => items.slice(1), [items]);
  const { pageItems, totalPages, currentPage, onPageChange } = usePaginatedItems(listItems);

  useEffect(() => {
    const loadBlogs = async () => {
      setLoading(true);
      try {
        const blogsRes = await getAllBlogs();
        setItems(parseBlogs(blogsRes));
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    loadBlogs();
  }, []);

  const renderFeatured = (item) => <HubFeatureCard firstBlog={item} />;

  return (
    <HubListingView
      title="Blogs"
      firstItem={firstItem}
      renderFeatured={renderFeatured}
      pageItems={pageItems}
      loading={loading}
      totalPages={totalPages}
      currentPage={currentPage}
      onPageChange={onPageChange}
    />
  );
}
